import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    document
      .querySelectorAll('[data-scroll], [data-contain="scroll"]')
      .forEach(el => {
        el.scrollTop = 0;
      });
  }, [location.pathname]);

  return null;
}
